import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

const YearSelect = props => {
    const { msgId, initialYear, years, onChangeHandler } = props;

    const [year, setYear] = useState(initialYear);

    return (
        <fieldset className="year-select">
            {msgId && (
                <label htmlFor="selectYear">
                    <FormattedMessage id={msgId} />
                </label>
            )}
            <select
                value={year}
                onChange={e => {
                    const selectedYear = parseInt(e.target.value);
                    setYear(selectedYear);
                    onChangeHandler(selectedYear);
                }}
                id="selectYear"
            >
                {years
                    .sort()
                    .reverse()
                    .map(year => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
            </select>
        </fieldset>
    );
};

export default YearSelect;
